import { Component, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSmartModalComponent } from 'ngx-smart-modal';
import { ResumeOnboardingService } from 'src/app/services/resume-onboarding.service';

@Component({
  selector: 'app-resume-onboarding-modal',
  templateUrl: './resume-onboarding-modal.component.html',
  styleUrls: ['./resume-onboarding-modal.component.scss']
})
export class ResumeOnboardingModalComponent {
  @Input() user: any;
  @ViewChild('onboardingModal') onboardingModal: NgxSmartModalComponent;

  private closedOnCurrentHomeVisit = false;

  constructor(private onboardingService: ResumeOnboardingService, private router: Router) { }

  open(): void {
    if (this.closedOnCurrentHomeVisit || !this.onboardingService.shouldShow(this.user)) return;

    setTimeout(() => this.onboardingModal?.open());
  }

  get hasCompleteResume(): boolean {
    return Number(this.user?.Seeker?.Completeness) > 50;
  }

  primaryAction(): void {
    this.onboardingModal.close();
    this.router.navigateByUrl(this.hasCompleteResume ? '/seeker/karpasha' : '/seeker/wizard');
  }

  close(): void {
    this.onboardingModal.close();
  }

  closeIfOpen(): void {
    if (this.onboardingModal?.isVisible()) this.close();
    this.closedOnCurrentHomeVisit = false;
    this.onboardingService.resetPostponement();
  }

  handleClose(): void {
    this.closedOnCurrentHomeVisit = true;
  }

  postpone(): void {
    this.onboardingService.postpone();
    this.close();
  }
}
